module.exports = {"id":"dp3_4l3q2","text":"Computational Thinking and Programming","instructions":"What distinguishes a computational model from real-world reality?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.4","questionType":"PickOne","random":true,"options":[{"id":"dp3_4l3q2-a1","text":"It simplifies aspects of reality to enable analysis","score":3.7},{"id":"dp3_4l3q2-a2","text":"It always represents reality in full detail","score":1.3},{"id":"dp3_4l3q2-a3","text":"It exists independently of human assumptions","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.4/l3q2.json
// module id = 1181
// module chunks = 41